<template>
  <Documents
    expanded
    :uploadUrl="uploadUrl"
    :data-documents="user.documents"
    title="Upload User Document"
    :extraFields="{ type: 'user' }"
    :uploadDocs="true"
    :deleteDocs="true"
  />
</template>
<script>
import Documents from "@/components/documents";
export default {
  components: { Documents },
  props: {
    user: { required: true },
  },
  computed: {
    uploadUrl() {
      return `api/v1/users/${this.user.id}/documents`;
    },
  },
};
</script>
